import api from "@services/api";
import axios, { type AxiosResponse } from "axios";

export interface ChatMessage {
  type: string;
  content: string;
}

export interface ChatResponse {
  messages: ChatMessage[];
}

export interface SendMessageRequest {
  userId: string;
  boraUserId: string;
  chatId: string;
  regional: string;
  empresa: string;
  messageType: string;
  text: string;
  username: string;
  platform: string;
  user_type?: string;
}

class ChatService {
  // private readonly baseURL =
  //   "https://orquestrador-prod-965761557956.southamerica-east1.run.app/invoke";
  // // "https://pmenechelli.app.n8n.cloud/webhook/751bef24-00ef-4203-9b6b-b3855ee2bb9b";
  // // private readonly apiKey = "12345";
  private readonly apiKey = "sk_live_aHR0cHM6Ly93d3cueW91dHViZS5jb20vd2F0Y2g";

  constructor() {
    // Configurar interceptors do axios se necessário
    axios.defaults.timeout = 500000;
  }

  private baseURL() {
    if (
      window.location.href.includes("localhost") ||
      window.location.href.includes(":3000") ||
      window.location.href.includes("dev") ||
      window.location.href.includes("qa") ||
      window.location.href.includes("stage")
    )
      return "https://dev-orquestrador-965761557956.southamerica-east1.run.app/invoke";
    else
      return "https://orquestrador-prod-965761557956.southamerica-east1.run.app/invoke";
  }

  async sendMessage(data: SendMessageRequest): Promise<ChatResponse> {
    try {
      console.log("Enviando dados para API:", data);

      const response: AxiosResponse<ChatResponse> = await axios.post(
        this.baseURL(),
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-API-Key": `${this.apiKey}`,
          },
          timeout: 180000, // 3 minutos para dar tempo suficiente para a resposta da API
        },
      );

      console.log("Resposta da API:", response.data);

      // Verificar se a resposta tem o formato esperado
      if (
        response.data &&
        response.data.messages &&
        Array.isArray(response.data.messages)
      ) {
        return response.data;
      } else {
        // Se a resposta não tem o formato esperado, tentar adaptar
        console.warn(
          "Formato de resposta inesperado, tentando adaptar:",
          response.data,
        );

        // Se a resposta é um array direto (formato antigo)
        if (Array.isArray(response.data)) {
          return {
            messages: response.data.map((item: any) => ({
              type: item.type || "text",
              content: item.content || item.text || String(item),
            })),
          };
        }

        // Se é uma string simples
        if (typeof response.data === "string") {
          return {
            messages: [
              {
                type: "text",
                content: response.data,
              },
            ],
          };
        }

        // Fallback para formato desconhecido
        return {
          messages: [
            {
              type: "text",
              content: "Resposta recebida em formato não reconhecido.",
            },
          ],
        };
      }
    } catch (error) {
      console.error("Erro ao enviar mensagem para o chat:", error);

      // Tratamento específico de erros do axios
      if (axios.isAxiosError(error)) {
        if (error.code === "ECONNABORTED") {
          throw new Error(
            "A resposta está demorando mais que o esperado. Tente novamente.",
          );
        } else if (error.response) {
          console.error("Erro de resposta do servidor:", error.response.data);
          throw new Error(
            `Erro do servidor: ${error.response.status} - ${error.response.statusText}`,
          );
        } else if (error.request) {
          throw new Error("Erro de conexão. Verifique sua internet.");
        } else {
          throw new Error("Erro na configuração da requisição.");
        }
      }

      throw error;
    }
  }

  async getAccessChatBot(regional: string) {
    try {
      const response = await api.get("/autenticacao/obter-acesso-chatbot", {
        params: { regional },
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const errorRes = error.response;
        return errorRes;
      }
    }
  }

  // Gerar um GUID para o chatId
  generateChatId(): string {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  // Salvar chatId na sessão
  saveChatId(chatId: string): void {
    sessionStorage.setItem("@chatId", chatId);
  }

  // Recuperar chatId da sessão
  getChatId(): string | null {
    return sessionStorage.getItem("@chatId");
  }

  // Limpar chatId da sessão
  clearChatId(): void {
    sessionStorage.removeItem("@chatId");
  }

  // Método para testar conectividade
  async testConnection(): Promise<boolean> {
    try {
      // Fazer uma requisição simples para testar se a API está acessível
      await axios.get(this.baseURL(), {
        timeout: 10000, // 10 segundos para teste de conectividade
        headers: {
          "X-API-Key": `${this.apiKey}`,
        },
      });
      return true;
    } catch (error) {
      console.warn("API do chat não está acessível:", error);
      return false;
    }
  }
}

const chatServiceInstance = new ChatService();
export default chatServiceInstance;
